import styled from 'styled-components';

import { SectionTitle } from '../../../../components';

/* The shared section title's own row (its 10px icon gap and 18px foot, off the scale there too), with the flask as its
   icon, so the heading lines up with every other section title. */
export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 18px;
  flex: none;
`;

export const Title = styled(SectionTitle)`
  margin-bottom: 0;
`;
